import type { Home } from "~/models/generated/Home";

export default defineNuxtPlugin( async () => {
  const { getByTypeSingle } = useContentDeliveryResource();
  const home = await getByTypeSingle<Home>( "home" );

  function checkMaintenanceMode () {
    if ( home.data.value && home.data.value.properties.enableMaintenanceMode ) {
      throw createError( {
        statusCode: 503,
        fatal: true,
        message: "Site is under maintenance. Please try again later.",
      } );
    }
  }

  addRouteMiddleware( "maintenance", checkMaintenanceMode );
  checkMaintenanceMode();
} );
